import LegalPage, { LegalSection } from '../components/LegalPage';
import { SITE } from '../lib/site';

const AvisoLegal = () => {
  return (
    <LegalPage title="Aviso Legal" updated="Actualizado: agosto de 2026" url="/aviso-legal">
      <LegalSection title="1. Titularidad del sitio web">
        <p>
          En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad
          de la Información y de Comercio Electrónico (LSSI-CE), se informa que el titular
          de este sitio web es {SITE.legalName}, con domicilio en Málaga (Andalucía, España),
          con correo electrónico de contacto {SITE.email} y teléfono {SITE.phoneDisplay}.
        </p>
      </LegalSection>
      <LegalSection title="2. Objeto">
        <p>
          El presente aviso legal regula el uso del sitio web {SITE.domain}, cuyo objeto
          es la presentación de los servicios de construcción, reformas integrales, obra
          nueva, rehabilitación y mantenimiento prestados por HGO Servicios en Málaga y
          la Costa del Sol, así como la captación de solicitudes de presupuesto.
        </p>
      </LegalSection>
      <LegalSection title="3. Propiedad intelectual">
        <p>
          Todos los contenidos de este sitio web —textos, imágenes, fotografías de obras,
          logotipos, estructura de diseño y elementos gráficos— son titularidad de HGO
          Servicios o de sus legítimos titulares, y quedan protegidos por la normativa de
          propiedad intelectual e industrial. Queda prohibida su reproducción, distribución
          o transformación sin autorización expresa por escrito.
        </p>
      </LegalSection>
      <LegalSection title="4. Responsabilidad">
        <p>
          HGO Servicios no se hace responsable del mal uso que se realice de los contenidos
          de este sitio web ni de los daños que pudieran derivarse del acceso o uso de la
          información contenida en el mismo. Las imágenes de proyectos son obras reales
          ejecutadas por la empresa; los precios mencionados son orientativos y no
          constituyen oferta contractual, debiendo confirmarse mediante presupuesto.
        </p>
      </LegalSection>
      <LegalSection title="5. Enlaces externos">
        <p>
          Este sitio puede contener enlaces a redes sociales y servicios externos
          (WhatsApp, Instagram, Facebook). HGO Servicios no controla el contenido de
          dichas páginas y no asume responsabilidad alguna sobre las mismas.
        </p>
      </LegalSection>
      <LegalSection title="6. Legislación aplicable y jurisdicción">
        <p>
          Las presentes condiciones se rigen por la legislación española. Para cualquier
          controversia derivada del uso de este sitio, las partes se someten a los
          juzgados y tribunales de Málaga, salvo que la ley disponga otra cosa.
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default AvisoLegal;
